import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContainer = styled.div`
  position: relative;
  width: 480px;
  max-width: 90vw;
  height: 680px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
`;

const ModalContentWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease;
`;

const PanelContent = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 30px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
`;

const CloseButton = styled.button`
  font-size: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

type ModalProps = {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  rightPanel?: React.ReactNode;
};

export default function ModalComponent({
  title,
  onClose,
  children,
  rightPanel,
}: ModalProps) {
  return (
    <Overlay>
      <ModalContainer>
        <ModalContentWrapper
          style={{ opacity: rightPanel ? 0 : 1, zIndex: rightPanel ? 0 : 1 }}
        >
          <PanelContent>
            <Header>
              <Title>{title}</Title>
              <CloseButton onClick={onClose}>×</CloseButton>
            </Header>
            <Content>{children}</Content>
          </PanelContent>
        </ModalContentWrapper>

        {rightPanel && (
          <ModalContentWrapper style={{ opacity: 1, zIndex: 2 }}>
            <PanelContent>{rightPanel}</PanelContent>
          </ModalContentWrapper>
        )}
      </ModalContainer>
    </Overlay>
  );
}
